import { HttpHeaders, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '../../interfaces/api-response';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { RemoteConfigService } from './remote-config.service';
import { Router } from '@angular/router';
import { MaintenanceModeError } from '../errors/maintenance-mode.error';
@Injectable({
  providedIn: 'root',
})
export class HttpService {
  private api_url = environment.HOST_LINK;
  constructor(
    private httpClient: HttpClient,
    private remoteConfigService: RemoteConfigService,
    private router: Router,
  ) {}


  headerOptions(): HttpHeaders {
    const headers: HttpHeaders = new HttpHeaders({
      Authorization: this.getAuthToken(),
    });
    return headers;
  }

  private getAuthToken(): string {
    const token: string | null = localStorage.getItem('token');
    return token ? JSON.parse(token) : '';
  }

  private async handleMaintenance(): Promise<void> {
    if (await this.remoteConfigService.isMaintenanceCached()) {
      if (this.router.url !== '/maintenance') {
        this.router.navigateByUrl('/maintenance');
      }
      throw new MaintenanceModeError();
    }
  }

  // TODO: remove this type any later for all REST functions

  async get<T = any>(endpoint: string): Promise<ApiResponse<T>> {
    try {
      await this.handleMaintenance();
    } catch (error) {
      throw error;
    }
    return new Promise((resolve) => {
      this.httpClient.get<ApiResponse<T>>(this.api_url + endpoint, { headers: this.headerOptions()}).subscribe({
        next: (data) => {
          resolve(data);
        },
        error: (error: HttpErrorResponse) => {
          resolve(error.error);
        },
      });
    });
  }

  getBlob(endpoint: string): Promise<{ blob: Blob, contentType: string }> {
    return new Promise((resolve, reject) => {
      this.httpClient.get(this.api_url + endpoint, { 
        headers: this.headerOptions(),
        responseType: 'blob',
        observe: 'response'
      }).subscribe({
        next: (response) => {
          const blob = response.body as Blob;
          const contentType = response.headers.get('Content-Type') || 'application/octet-stream';
          resolve({ 
            blob, 
            contentType 
          });
        },
        error: (error) => reject(error)
      });
    });
  }

  async post<T = any>(endpoint: string, body: any): Promise<ApiResponse<T>> {
    try {
      await this.handleMaintenance();
    } catch (error) {
      throw error;
    }
    return new Promise((resolve) => {
      this.httpClient
        .post<ApiResponse<T>>(this.api_url + endpoint, body,{ headers: this.headerOptions()})
        .subscribe({ 
          next: (data) => {
            resolve(data);
          },
          error: (error: HttpErrorResponse) => {
            resolve(error.error);
          },
        });
    });
  }

  async put<T = any>(endpoint: string, body: any): Promise<ApiResponse<T>> {
    try {
      await this.handleMaintenance();
    } catch (error) {
      throw error;
    }
    return new Promise((resolve) => {
      this.httpClient
        .put<ApiResponse<T>>(this.api_url + endpoint, body, {
          headers: this.headerOptions(),
        })
        .subscribe({
          next: (data) => {
            resolve(data);
          },
          error: (error: HttpErrorResponse) => {
            resolve(error.error);
          },
        });
    });
  }

  async patch<T = any>(endpoint: string, body: any): Promise<ApiResponse<T>> {
    try {
      await this.handleMaintenance();
    } catch (error) {
      throw error;
    }
    return new Promise((resolve) => {
      this.httpClient
        .patch<ApiResponse<T>>(this.api_url + endpoint, body, {
          headers: this.headerOptions(),
        })
        .subscribe({
          next: (data) => {
            resolve(data);
          },
          error: (error) => {
            resolve(error);
          },
        });
    });
  }

  async delete<T = any>(endpoint: string): Promise<ApiResponse<T>> {
    try {
      await this.handleMaintenance();
    } catch (error) {
      throw error;
    }
    return new Promise((resolve) => {
      this.httpClient
        .delete<ApiResponse<T>>(this.api_url + endpoint, {
          headers: this.headerOptions(),
        })
        .subscribe({
          next: (data) => {
            resolve(data);
          },
          error: (error) => {
            resolve(error);
          },
        });
    });
  }

  getTokens<T = any>(endpoint: string): Observable<ApiResponse<T>> {
    return this.httpClient.get<ApiResponse<T>>(this.api_url + endpoint, { headers: this.headerOptions() });
  }

  // getFile(endpoint: string): Promise<any> {
  //   return new Promise((resolve) => {
  //     this.httpClient.get(endpoint ,{responseType: 'blob' }).subscribe({
  //       next: (data) => {
  //         resolve(data);
  //       },
  //       error: (error) => {
  //         resolve(error);
  //       },
  //     });
  //   });
  // }

  getFile(endpoint: string): Observable<any> {
    return this.httpClient.get(endpoint, { responseType: 'blob' });
  }

  uploadFile(endpoint: string, body: any): Observable<any> {
    return this.httpClient.put(endpoint, body, { observe: 'response' });
  }
}
